import React, { useRef, useState } from "react";
import JoditEditor from "jodit-react";
import { ResizableBox } from "react-resizable";
import "jodit/es5/jodit.min.css";
import "react-resizable/css/styles.css"; // Make sure to include resizable CSS

const Editor = () => {
    const editor = useRef(null);

    const [editorHeight, setEditorHeight] = useState(1000); // Track editor height
    const [editorWidth, setEditorWidth] = useState(800); // Track editor width

    const config = {
        readonly: false,
        toolbarButtonSize: "large",
        showCharsCounter: true,
        buttons: [
            "bold", "italic", "underline", "strikethrough", "align", "outdent",
            "indent", "link", "image", "video", "quote", "code", "list", "table",
            "undo", "redo", "brush", "font", "fontsize", "forecolor", "backcolor",
            "highlight", "left", "center", "right", "justify", "fontname",
            "fontsize", "paragraph", "lineheight", "print"
        ],
        uploader: {
            url: '/api/upload',
            insertImageAsBase64URI: true,
            imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
            format: 'json',
            prepareData: (formData) => {
                const file = formData.get('files[0]');
                if (file) {
                    formData.append('file', file);
                    return formData;
                }
                return null;
            },
            process: (response) => {
                if (!response) {
                    return {
                        files: [],
                        error: 1,
                        msg: 'No file selected'
                    };
                }
                return {
                    files: [response.fileName || response.name],
                    path: response.filePath || '',
                    baseurl: '/uploads',
                    error: response.success ? 0 : 1,
                    msg: response.message || 'File uploaded successfully'
                };
            },
            error: (e) => {
                console.error('Upload error:', e);
                alert(`Upload failed: ${e.message || 'Please try again.'}`);
            }
        },
        filebrowser: {
            ajax: {
                url: '/api/upload',
            },
            images: {
                baseurl: '/uploads',
            },
        },
        enableDragAndDropFileToEditor: true,
        showMessageError: true,
        showMessageSuccess: true,
        style: {
            ".jodit-editor": {
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                minHeight: "1000px",
                height: `${editorHeight}px`,   // Use dynamic height here
                width: `${editorWidth}px`,       // Use dynamic width here
                border: "1px solid #ccc",
                margin: "auto",
                padding: "20px",
                backgroundColor: "#ffffff",
                overflowY: "auto",
            },
        },
    };

    const saveAsPDF = () => {
        if (editor.current && editor.current.editor) {
            editor.current.editor.exportPDF({
                fileName: "resume.pdf",
                margins: [10, 10, 10, 10],
                scale: 1.5
            }).then(() => {
                console.log("PDF exported successfully");
            }).catch((error) => {
                console.error("Error exporting PDF:", error);
            });
        }
    };

    const handleResize = (e, data) => {
        setEditorWidth(data.size.width);
        setEditorHeight(data.size.height);
    };

    return (
        <div className="container mt-4 text-center">
            <h1>Edit Your Resume Here</h1>

            <div className="mt-4">
                {/* Resizable Box for the Jodit Editor */}
                <ResizableBox
                    width={editorWidth}
                    height={editorHeight}
                    minConstraints={[300, 400]} // Min size
                    maxConstraints={[1200, 1200]} // Max size
                    axis="both" // Allow resizing both width and height
                    onResizeStop={handleResize} // Handle resizing stop event
                >
                    <div className="editor-container">
                        <JoditEditor
                            ref={editor}
                            config={config}
                        />
                    </div>
                </ResizableBox>
            </div>
        </div>
    );
};

export default Editor;
